import { useSelector } from 'react-redux';
import { getCaseBattleList } from '../ducks';

export const useGetBattleList = () => ({
  caseBattle: useSelector(getCaseBattleList),
});
